module.exports = __webpack_public_path__ + "static/media/linkedin.63e78299.svg";